import React from 'react';
import { Button } from '@base/lib/Button';
import { useRouter } from 'next/router';
import { DEBUG_SERVER } from 'base/config/constant';
import styles from './index.module.less';

const Index: React.FC<any> = props => {
    const { query } = useRouter();

    return process.env.NODE_ENV === 'development' || query[DEBUG_SERVER] === '1' ? (
        <Button
            type="dashed"
            shape="circle"
            size="small"
            onClick={() => console.log(props)}
            className={styles.btn}
        >
            S
        </Button>
    ) : null
};

export default Index;
